import React from 'react';
import { Chip } from '@heroui/react';
import { TransactionData } from '../types';

interface TransactionAmountCellProps {
  transaction: TransactionData;
}

const TransactionAmountCell: React.FC<TransactionAmountCellProps> = ({ transaction }) => {
  const getChipColor = (type: string) => {
    switch (type.toLowerCase()) {
      case 'tip':
        return 'danger';
      case 'chat_messages':
        return 'success';
      case 'post':
        return 'secondary';
      case 'message':
        return 'success';
      default:
        return 'default';
    }
  };

  const formatTransactionType = (type: string) => {
    switch (type.toLowerCase()) {
      case 'chat_messages':
        return 'Message';
      case 'tip':
        return 'Tip';
      case 'post':
        return 'Post';
      default:
        return type;
    }
  };

  const formatAmount = (amount: string) => {
    const numAmount = parseFloat(amount);
    return isNaN(numAmount) ? '$0.00' : `$${numAmount.toFixed(2)}`;
  };

  return (
    <div className="flex flex-col gap-2">
      {/* Сумма транзакции */}
      <span className="font-semibold text-sm">
        {formatAmount(transaction.amount - transaction.fee)}
      </span>

      {/* Чип типа транзакции */}
      <Chip
        size="sm"
        color={getChipColor(transaction.transactionType)}
        variant="flat"
        className="w-fit"
      >
        {formatTransactionType(transaction.transactionType)}
      </Chip>
    </div>
  );
};

export default TransactionAmountCell;
